
const getParameterByName = function(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

const getOverrides = function(){
    var style = {
        up: "#13b887",//"#13B887", // 蓝色
        down: "#eb4d5c",//"#EB4D5C", // 红色

        bg: "#fff",
        grid: "#fff",
        cross: "#1E2740",
        border: "#fff",
        text: "#61688A",
        areatop: "rgba(122, 152, 247, .1)",
        areadown: "rgba(122, 152, 247, .02)"
    };
    return {
        volumePaneSize: "medium", //large, medium, small, tiny
        "paneProperties.topMargin": "20",
        "scalesProperties.lineColor": style.text,
        "scalesProperties.textColor": style.text,
        "paneProperties.background": style.bg, //改变背景色的重要代码
        "paneProperties.vertGridProperties.color": style.grid,
        "paneProperties.horzGridProperties.color": style.grid,
        "paneProperties.crossHairProperties.color": style.cross,
        "paneProperties.legendProperties.showLegend": true,
        "paneProperties.legendProperties.showStudyArguments": true,
        "paneProperties.legendProperties.showStudyTitles": true,
        "paneProperties.legendProperties.showStudyValues": true,
        "paneProperties.legendProperties.showSeriesTitle": true,
        "paneProperties.legendProperties.showSeriesOHLC": true,
        "mainSeriesProperties.candleStyle.upColor": style.up,
        "mainSeriesProperties.candleStyle.downColor": style.down,
        "mainSeriesProperties.candleStyle.drawWick": true,
        "mainSeriesProperties.candleStyle.drawBorder": true,
        "mainSeriesProperties.candleStyle.borderColor": style.border,
        "mainSeriesProperties.candleStyle.borderUpColor": style.up,
        "mainSeriesProperties.candleStyle.borderDownColor": style.down,
        "mainSeriesProperties.candleStyle.wickUpColor": style.up,
        "mainSeriesProperties.candleStyle.wickDownColor": style.down,
        "mainSeriesProperties.candleStyle.barColorsOnPrevClose": false,
        "mainSeriesProperties.hollowCandleStyle.upColor": style.up,
        "mainSeriesProperties.hollowCandleStyle.downColor": style.down,

        "mainSeriesProperties.hollowCandleStyle.drawWick": true,
        "mainSeriesProperties.hollowCandleStyle.drawBorder": true,
        "mainSeriesProperties.hollowCandleStyle.borderColor": style.border,
        "mainSeriesProperties.hollowCandleStyle.borderUpColor": style.up,
        "mainSeriesProperties.hollowCandleStyle.borderDownColor": style.down,
        "mainSeriesProperties.hollowCandleStyle.wickColor": style.line,
        "mainSeriesProperties.haStyle.upColor": style.up,
        "mainSeriesProperties.haStyle.downColor": style.down,
        "mainSeriesProperties.haStyle.drawWick": true,
        "mainSeriesProperties.haStyle.drawBorder": true,
        "mainSeriesProperties.haStyle.borderColor": style.border,
        "mainSeriesProperties.haStyle.borderUpColor": style.up,
        "mainSeriesProperties.haStyle.borderDownColor": style.down,
        "mainSeriesProperties.haStyle.wickColor": style.border,
        "mainSeriesProperties.haStyle.barColorsOnPrevClose": false,
        "mainSeriesProperties.barStyle.upColor": style.up,
        "mainSeriesProperties.barStyle.downColor": style.down,
        "mainSeriesProperties.barStyle.barColorsOnPrevClose": false,
        "mainSeriesProperties.barStyle.dontDrawOpen": false,
        "mainSeriesProperties.lineStyle.color": style.border,
        "mainSeriesProperties.lineStyle.linewidth": 1,
        "mainSeriesProperties.lineStyle.priceSource": "close",
        "mainSeriesProperties.areaStyle.color1": style.areatop,
        "mainSeriesProperties.areaStyle.color2": style.areadown,
        "mainSeriesProperties.areaStyle.linecolor": style.border,
        "mainSeriesProperties.areaStyle.linewidth": 1,
        "mainSeriesProperties.areaStyle.priceSource": "close"
    }
}
const getDisabledFeatures = function (){
    return [
        //  禁用的功能
        "left_toolbar",
        "header_saveload",
        "compare_symbol",
        "display_market_status",
        "go_to_date",
        "header_chart_type",
        "header_compare",
        "header_interval_dialog_button",
        "header_resolutions",
        "header_screenshot",
        "header_symbol_search",
        "header_undo_redo",
        "legend_context_menu",
        "show_hide_button_in_legend",
        "show_interval_dialog_on_key_press",
        "snapshot_trading_drawings",
        "symbol_info",
        "timeframes_toolbar",
        "use_localstorage_for_settings",
        "volume_force_overlay",
        "widget_logo"
    ]
}

const getEnabledFeatures = function(){
    return [
        // 启用的功能（备注：disable_resolution_rebuild 功能用于控制当时间范围为1个月时，日期刻度是否都是每个月1号
        "dont_show_boolean_study_arguments",
        "hide_last_na_study_output",
        "move_logo_to_main_pane",
        "same_data_requery",
        "side_toolbar_in_fullscreen_mode",
        "disable_resolution_rebuild",
        "header_indicators"
    ]
}

const buttonArr = [
    {
        value: "1",
        period: "1m",
        text: "Time",
        chartType: 3,
        type: "1min"
    },
    {
        value: "1",
        period: "1m",
        text: "1min",
        chartType: 1,
        type: "1min"
    },
    {
        value: "5",
        period: "5m",
        text: "5min",
        chartType: 1,
        type: "5min"
    },
    {
        value: "15",
        period: "15m",
        text: "15min",
        chartType: 1,
        type: "15min"
    },
    {
        value: "30",
        period: "30m",
        text: "30min",
        chartType: 1,
        type: "30min"
    },
    {
        value: "60",
        period: "60分钟",
        text: "1hour",
        chartType: 1,
        type: "60min"
    },
    {
        value: "1D",
        period: "1D",
        text: "1day",
        chartType: 1,
        type: "1day"
    },
    {
        value: "1W",
        period: "1W",
        text: "1week",
        chartType: 1,
        type: "1week"
    },
    // {
    //     value: "1M",
    //     period: "1M",
    //     text: "1mon",
    //     chartType: 1,
    //     type: "1mon"
    // }
]

const TV = {
    getParameterByName,
    getOverrides,
    getDisabledFeatures,
    getEnabledFeatures,
    buttonArr
}

export default TV



// WEBPACK FOOTER //
// ./src/views/deal/components/AoTv-p.js